<div class="row contenedor-detalle-siniestro mx-1">
    <div class="col-lg-4  col-md-6 col-sm-6 col-12">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">SINIESTRO</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 info-group mt-2 mb-2">
                <div class="info-row">
                    <small class="titulo info-label">Moneda: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.monedak}}</strong>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.desc_monedak}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Ramo: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.ramok}}</strong>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.desc_ramok}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Sramo: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.sramok}}</strong>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.desc_sramok}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Oficina: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.oficinak}}</strong>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.desc_oficinak}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Siniestro: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.conseck}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Año: </small>
                    <strong class="valorTextoWeight-500 info-value">{{siniestroCompleto?.aak}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4  col-md-6 col-sm-6 col-12"
        [ngClass]="{'borde-izquierdo' : !['xs', 'sm' ,'md'].includes(screenSize)}">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">PÓLIZA</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 info-group mt-2 mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Sucursal: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza">{{siniestroCompleto?.sucursalk1}}</strong>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{siniestroCompleto?.desc_sucursalk1}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Póliza: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza"
                        [matTooltip]="detalleComplementoSiniestro?.desc_statpol">{{siniestroCompleto?.polizak1}}</strong>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{siniestroCompleto?.desc_contratante}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Inciso: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza"
                        [matTooltip]="detalleComplementoSiniestro?.desc_statpol"
                        [matTooltipPosition]="'right'">{{siniestroCompleto?.incisok1}}
                    </strong>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{siniestroCompleto?.desc_asegurado}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Vehículo: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza">{{siniestroCompleto?.vehiculo}}</strong>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle"
                        [matTooltip]="siniestroCompleto?.desc_vehiculo +' MOD. ' + siniestroCompleto?.modelo"
                        [matTooltipPosition]="'right'">
                        {{siniestroCompleto?.desc_vehiculo}}
                    </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Endoso: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{siniestroCompleto?.endosok1}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Días pendientes de pago: </small>
                    <strong
                        class="valorTextoWeight-500 info-value-poliza-detalle">{{detalleComplementoSiniestro?.dias_pendiente_pago}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Status VIN: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza">{{siniestroCompleto?.numerico}}</strong>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{siniestroCompleto?.alpha}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Evento: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{siniestroCompleto?.desc_evento}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-label">Status Cob: </small>
                    <strong class="valorTextoWeight-500 info-value-poliza-detalle">{{detalleComplementoSiniestro?.desc_stcob}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-4  col-md-12 col-sm-12 col-12 borde-izquierdo"
        [ngClass]="{'borde-izquierdo' : !['xs', 'sm', 'md'].includes(screenSize)}">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">FECHAS Y HORAS</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 col-12 info-group mt-2 mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Ocurrido: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.fecsini}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horasini}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Reclamado: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.fecrecla}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horarecla}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Registro: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.fecreg}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horareg}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Aviso: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.fecaviso == "01/01/1901" ? '' :
                        siniestroCompleto?.fecaviso }}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horaviso}}</strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Incio de atención: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.feciniatn == "01/01/1901" ? ''
                        : siniestroCompleto?.feciniatn }}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horainiatn == "" ? '' :
                        siniestroCompleto?.horainiatn}}
                        </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Fin de atención: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.fecfinatn == "01/01/1901" ? ''
                        : siniestroCompleto?.fecfinatn }}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horafinatn == "" ? '' :
                        siniestroCompleto?.horafinatn}}
                        </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Por cita: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita">{{siniestroCompleto?.cita}}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.feccita == "01/01/1901" ? '' :
                        siniestroCompleto?.feccita }}</strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{siniestroCompleto?.horacita == "" ? '' :
                        siniestroCompleto?.horacita}}
                        </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Tiempo de Asignación: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{''}}</strong>
                    <strong
                        class="valorTextoWeight-500 info-value-fecha-value">{{detalleComplementoSiniestro?.TiempoAsignacion}}
                    </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Tiempo de Llegada: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{''}}</strong>
                    <strong
                        class="valorTextoWeight-500 info-value-fecha-value">{{detalleComplementoSiniestro?.TiempoLlegada}}
                    </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Tiempo de Arribo: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-cita"></strong>
                    <strong class="valorTextoWeight-500 info-value-fecha-value">{{''}}</strong>
                    <strong
                        class="valorTextoWeight-500 info-value-fecha-value">{{detalleComplementoSiniestro?.TiempoArribo}}
                    </strong>
                </div>
            </div>
            <div class="col-md-12 col-12 info-group mb-2">
                <div class="info-row">
                    <small class="titulo  info-value-fecha-label">Garantía: </small>
                    <strong class="valorTextoWeight-500 info-value-fecha-garantia">{{siniestroCompleto?.desc_winterthur}}</strong>
                </div>
            </div>
        </div>
    </div>
</div>